import styled from 'styled-components';

export const QaPageConteiner = styled.div`
`;
